import React from "react";
import CustomDialog from "../../UniversalComponents/CustomDialog";
import SubmoduleNav from "./SubmoduleNav";
import AddTask from "../AddTask";
import AddNotes from "../notes";
import CustomerDocument from "../Documents/CustomerDocument";

const componentList = {
  TaskModule: AddTask,
  CustomerNotes: AddNotes,
  CustomerDocument: CustomerDocument,
};

function Submodules({
  activeSubmodule = {},
  setActiveSubmodule = () => null,
  onClose = () => null,
  fullScreen = false,
  items = [],
  moduleId,
}) {
  const PageContent = componentList[activeSubmodule.component] || (() => <div>No Component Found</div>);
  return (
    <CustomDialog fullScreen maxWidth="lg" fullWidth open={true} onClose={onClose}>
      <div className=" flex flex-col h-full gap-4">
        {/* navigation */}
        <div className="flex items-center justify-between">
          <SubmoduleNav
            items={items}
            subTabValue={activeSubmodule.value}
            disableRouting
            onSelect={(val) => setActiveSubmodule(val)}
          />
          <button onClick={onClose} className="text-gray-500 hover:text-gray-800 text-xl">
            <i className="bi bi-x-lg"></i>
          </button>
        </div>

        {/* divider */}
        <div className="border-b border-[rgba(19, 19, 19, 0.08)]"></div>

        {/* content */}
        <div className="grow min-h-0 ">
          <PageContent
            // customerGData={customerGData}
            // type={section.type ? section.type : ""}
            // leadType={section.value === "my-assignment" ? "project" : "task"}
            // subNavitems={section?.items}
            // setRefetch={setRefetch}
            // customerId={customerId}
            propTemplateId={moduleId}
            moduleTaskId={activeSubmodule?.value}
            disableAddMode
            // fullScreen={section?.is_custom_module}
          />
        </div>
      </div>
    </CustomDialog>
  );
}

export default Submodules;
